import React, { useEffect, useState } from "react";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import Modal from "react-bootstrap/Modal";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import OTPInput from "react-otp-input";
import "./Banner.css";
import { useHistory } from "react-router-dom";
import {
  refreshExistingUserAction,
  verifyEmailAddressAction,
  verifyOTPAction,
} from "../store/actions/AuthAction";
import { useDispatch, useSelector } from "react-redux";
import AlertSnackbar from "../components/AlertSnackbar/AlertSnackbar";

function Banner() {
  const dispatch = useDispatch();
  const history = useHistory();
  const authData = useSelector((state) => state.auth);
  const [show, setShow] = useState(false);
  const [emailAddress, setEmailAddress] = useState("");
  const [emailError, setEmailError] = React.useState("");
  const [alertShow, setAlertShow] = useState(false);
  const loader = useSelector((state) => state.loader);
  const handleClose = () => {
    dispatch(refreshExistingUserAction());
    setShow(false);
  };

  useEffect(() => {
    //refresh existing user
    dispatch(refreshExistingUserAction());
    history.replace("/");
  }, []);

  useEffect(() => {
    !authData?.currentUser && setShow(authData.currentUser);
    if (authData?.userExists != undefined && !authData?.userExists) {
      dispatch(refreshExistingUserAction());
      history.push("/assessment");
      window.location.reload();
    }
    if (authData?.currentUser && authData?.userToken && authData?.loggedIn) {
      history.push("/app");
      window.location.reload();
    }
  });

  const handleEmailInput = (e) => {
    const inputValue = e.target.value;
    if (inputValue && !/\S+@\S+\.\S+/.test(inputValue)) {
      setEmailError("Email format must be as example@mail.com");
    } else {
      setEmailError("");
    }
    setEmailAddress(e.target.value);
  };

  const handleShow = () => {
    if (emailError === "") {
      const requestPayload = {
        action: "verifyEmail",
        data: emailAddress,
      };
      dispatch(verifyEmailAddressAction(requestPayload));
    }
  };
  const [OTP, setOTP] = useState("");
  let [error, setError] = React.useState("");
  let phoneNumbers = [];

  const errorMessage = (message) => {
    setError(message);
    setTimeout(() => setError(""), 4000);
  };
  const handleSubmit = () => {
    if (OTP.length === 0) {
      errorMessage("Please Enter otp");
    } else if (OTP.length !== 6) {
      errorMessage("Digits in OTP number should be equal to 6");
      return;
    } else {
      phoneNumbers.push(OTP);
      const requestPayload = {
        action: "verifyOTP",
        data: {
          token: authData?.userToken,
          otp: OTP,
        },
      };
      dispatch(verifyOTPAction(requestPayload));
      setShow(false);
      // history.push("/app");
    }
  };

  function handleChange(OTP) {
    setOTP(OTP);
  }

  return (
    <div
      className="banner"
      style={{
        backgroundSize: "cover",
        background:
          "linear-gradient(90deg, rgba(2,0,36,1) 0%, rgba(9,9,121,1) 35%, rgba(0,212,255,1) 100%)",

        textAlign: "center",
      }}
    >
      {loader?.isLoading && (
        <div className="loader-outer">
          <h3 className="txt-message">Loading...</h3>
        </div>
      )}
      {alertShow && authData?.error && (
        <AlertSnackbar
          isAlertShown={alertShow && authData?.error}
          alertType="danger"
          alertMessage="Something went wrong. Please try again."
          setShow={() => setAlertShow(false)}
        />
      )}
      <div className="container">
        <div className="row">
          <div className="col-sm-12">
            <h1 className="display-4 fw-bold">
              Welcome to GMSDC MBE Engagement Assessment
            </h1>
          </div>
        </div>
        <Row className="banner-row">
          <Col md={6} sm={12}>
            <div className="content-banner left">
              <p>
                This assessment contains 25 questions that will be used as the
                foundation for your GMSDC MBE development process. This
                assessment should take about 10 mins to complete.
              </p>
              <p>
                You will receive a confirmation email that will provide you with
                a link to use to go back into your assessment at any time.
              </p>
              <p>
                Your results will be used by GMSDC team members to assist in
                your development journey.
              </p>
              <p>
                If you have any questions, please email the GMSDC team at MBE
                Services @gmsdc.org.
              </p>
            </div>
          </Col>
          <Col style={{ textAlign: "left" }} md={6} sm={12}>
            <div className="content-banner right">
              <h4 className="email-title">
                Enter your email address to begin assessment
              </h4>
              <Form className="get-started-form">
                <Form.Group
                  className="mb-3"
                  controlId="exampleForm.ControlInput1"
                >
                  <Form.Control
                    type="email"
                    placeholder="name@example.com"
                    autoFocus
                    required
                    value={emailAddress}
                    onChange={(e) => handleEmailInput(e)}
                  />
                </Form.Group>
                <h3 className="emailError">{emailError}</h3>
                <Button
                  variant="success"
                  disabled={
                    emailAddress === "" ||
                    (emailAddress !== "" && emailError !== "")
                  }
                  onClick={handleShow}
                >
                  Get Started
                </Button>
              </Form>
            </div>
          </Col>
        </Row>
        <Modal show={authData?.currentUser || show} onHide={handleClose}>
          <Modal.Header closeButton>Verify your email address</Modal.Header>
          <Modal.Body>
            <div className="container">
              <h6>
                Please enter the one time password <br /> to verify your account
              </h6>
              <div id="otp">
                <OTPInput
                  onChange={handleChange}
                  value={OTP}
                  inputStyle="m-2 text-center form-control rounded"
                  numInputs={6}
                  isInputNum={true}
                  separator={<span></span>}
                />
              </div>
              <h3 className="error">{error}</h3>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <Button
              variant="primary"
              disabled={OTP === ""}
              onClick={() => handleSubmit()}
            >
              Validate
            </Button>
          </Modal.Footer>
        </Modal>
      </div>
    </div>
  );
}

export default Banner;
